import { render, staticRenderFns } from "./a.vue?vue&type=template&id=98294fdc"
import script from "./a.vue?vue&type=script&lang=js"
export * from "./a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports